(function () {
    'use strict';

    angular
        .module('NaviaqWebApp')
        .factory('productCatalogService', productCatalogService);

    productCatalogService.$inject = [
        '$http',
        'serviceUrls',
    ];

    function productCatalogService(
        $http,
        serviceUrls,
    ) {
        const productCatalogApiServiceUrl = `${serviceUrls.vendorsApiBaseUrl}/productCatalog`;

        return {
            getSupplierProductCatalogByFilter,
            getComponentTypes
        };

        async function getSupplierProductCatalogByFilter(filter) {
            try {
                const response = await $http.get(`${productCatalogApiServiceUrl}/?vendor=${filter.vendorId}${filter.componentType ? `&componentType=${filter.componentType}` : ''}`);
                if (response?.data) return response.data;
                throw new Error('No data');
            } catch (error) {
                throw error;
            }
        }

        async function getComponentTypes() {
            try {
                let locale = localStorage.getItem('NG_TRANSLATE_LANG_KEY');
                if (!locale) locale = 'no';
                
                const response = await $http.get(`${productCatalogApiServiceUrl}/componentTypes?locale=${locale}`);
                if (response?.data) return response.data;
                throw new Error('No data');
            } catch (error) {
                throw error;
            }
        }
    }
})();
